/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined) {
        "use strict";
        skyward.securityrolecloneapproval = skyward.securityrolecloneapproval || {};

        skyward.securityrolecloneapproval.detailsGetConsentForSecurityRoleClone = function (cloneroleid, securityHash) {
            makeAjaxCall("Security/SecurityRoleCloneApproval/GetConsentForSecurityRoleClone", cloneroleid, securityHash)
        };

        skyward.securityrolecloneapproval.getConsentForSecurityRoleClone = function () {
            var buttonData = $(this).data();
            makeAjaxCall("Security/SecurityRoleCloneApproval/GetConsentForSecurityRoleClone", buttonData.cloneroleid, buttonData.cloneroleid_securityhash);
        };

        var consentAndRedirect = function () {
            var buttonData = $(this).data();
            makeAjaxCall("Security/SecurityRoleCloneApproval/ApproveAndRedirect", buttonData.cloneRoleID, buttonData.securityHash, buttonData.redirectAction);
        };

        var makeAjaxCall = function (url, roleID, securityHash, redirectAction) {
            var postData =
            {
                cloneRoleID: roleID,
                securityHash: securityHash,
                redirectAction: redirectAction
            };

            $.ajax({
                url: skyward.global.virtualDir + url,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data) {
                    handleAjaxResponse(data, roleID, securityHash);
                }
            });
        };

        var handleAjaxResponse = function (data, roleID, securityHash) {
            if (data.requiresApproval) {
                var consentButton =
                {
                    text: "I Consent", click: consentAndRedirect, icon: "Check",
                    data:
                    {
                        "cloneRoleID": roleID,
                        "redirectAction": data.redirectAction,
                        "securityHash": securityHash
                    }
                };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                skyward.modalLayer.showCriticalDialog("SECURITY ROLE CLONE AGREEMENT", data.html, [consentButton, cancelButton], { width: 600, automationID: "securityroleclone-consent-dialog" });
            }
            else {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Security/Role/Clone', null, data.workflowData, null, null, null, false, null, null, null);
                }
        };

        var events =
        {
            'getConsentForSecurityRoleClone': skyward.securityrolecloneapproval.getConsentForSecurityRoleClone,
        };

        skyward.events.registerEvents('securityrolecloneapproval', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);